import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=59c249e4&scoped=true&"
import script from "./banners.vue?vue&type=script&lang=js&"
export * from "./banners.vue?vue&type=script&lang=js&"
import style0 from "./banners.vue?vue&type=style&index=0&id=59c249e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c249e4",
  null
  
)

export default component.exports